import React from "react";
import { Link } from "react-router-dom";
import ErrorReportTable from "./ErrorReportTable.jsx";

const RecentErrorReports = ({ error_reports, resolutionFilter, applyResolutionFilter }) => {
   let filteredReports = error_reports || [];
   if (resolutionFilter === "resolved") {
      filteredReports = filteredReports.filter((r) => r.resolved === true);
   } else if (resolutionFilter === "unresolved") {
      filteredReports = filteredReports.filter(
         (r) => r.resolved === null || r.resolved === undefined
      );
   }

   return (
      <div className="content-card full-width">
         <div className="card-header">
            <h3 className="card-title">
               <i className="bi bi-exclamation-triangle"></i>
               Recent Error Reports
               {resolutionFilter && (
                  <span className="badge badge-custom badge-info ms-2">
                     Filtered:{" "}
                     {resolutionFilter.charAt(0).toUpperCase() + resolutionFilter.slice(1)}
                  </span>
               )}
            </h3>
            <div className="card-actions">
               {filteredReports.length > 0 && (
                  <Link to="/forms?error_status=with_errors" className="btn-action primary">
                     View All
                     <i className="bi bi-arrow-right"></i>
                  </Link>
               )}
            </div>
         </div>
         {/* Filter Controls */}
         <div
            className="mb-3 p-3"
            style={{ background: "var(--secondary-color)", borderRadius: "8px" }}
         >
            <div
               style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "1rem",
               }}
            >
               <div>
                  <label htmlFor="resolutionFilter" className="form-label mb-2">
                     <i className="bi bi-funnel"></i>
                     Filter by Resolution Status:
                  </label>
                  {resolutionFilter && resolutionFilter !== "all" && (
                     <div className="text-muted small">
                        Showing {filteredReports.length} filtered result
                        {filteredReports.length !== 1 ? "s" : ""}
                     </div>
                  )}
               </div>
               <div>
                  <select
                     id="resolutionFilter"
                     className="form-select"
                     value={resolutionFilter || "all"}
                     onChange={(e) => applyResolutionFilter(e.target.value)}
                     style={{
                        padding: "0.5rem",
                        border: "1px solid var(--border-color)",
                        borderRadius: "6px",
                        background: "white",
                     }}
                  >
                     <option value="all">All Reports</option>
                     <option value="unresolved">Unresolved Only</option>
                     <option value="resolved">Resolved Only</option>
                  </select>
               </div>
            </div>
         </div>
         {filteredReports.length > 0 ? (
            <ErrorReportTable error_reports={filteredReports.slice(0, 5)} />
         ) : (
            <div className="empty-state">
               <i className="bi bi-check-circle"></i>
               {resolutionFilter === "resolved" ? (
                  <p>No resolved error reports found</p>
               ) : resolutionFilter === "unresolved" ? (
                  <p>No unresolved error reports found</p>
               ) : (
                  <p>No error reports found</p>
               )}
               {resolutionFilter && resolutionFilter !== "all" && (
                  <button
                     className="btn btn-outline-primary mt-2"
                     onClick={() => applyResolutionFilter("all")}
                     style={{
                        marginTop: "0.5rem",
                        padding: "0.5rem 1rem",
                        border: "1px solid var(--primary-color)",
                        background: "transparent",
                        color: "var(--primary-color)",
                        borderRadius: "6px",
                        cursor: "pointer",
                     }}
                  >
                     <i className="bi bi-arrow-clockwise"></i> Clear Filter
                  </button>
               )}
            </div>
         )}
      </div>
   );
};

export default RecentErrorReports;
